import { useContext, useEffect, useRef, useState, useCallback } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { MapContext } from "../context/MapContext";
import {
  createSwitchBtn,
  maplibreInit,
  setSwitchBtnClickHandler,
} from "../utils/MapManager";
import GoogleAd from "./GoogleAd";
import TokuteishohyokiModal from "./modal/TokuteishohyokiModal";
import IndividualDrawColorSettingBtn from "./IndividualDrawColorSettingBtn";
import { useAuthStatus } from "../context/AuthContext";
import ChibanSearchModal from "./modal/ChibanSearchModal";
import NiniMapModal from "./modal/NiniMapModal";
import OrderHistoryModal from "./modal/OrderHistoryModal";

const Map = () => {
  const mapContinerRef = useRef();
  const {
    setMap,
    drawColorRef,
    setDrawCtl,
    setHasUrlHash,
    addSelectedFeatures,
    deleteSelectedFeatures,
  } = useContext(MapContext);
  const { isLoading, isUserLoggedIn, userInfo } = useAuthStatus();
  const drawColor = drawColorRef.current;

  const [smartphoneText, setSmartphoneText] = useState(null);
  const [linkUrl, setLinkUrl] = useState(null);
  const [tokuteishohyokiModalSow, setTokuteishohyokiModalSow] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [showChibanSearch, setShowChibanSearch] = useState(false);
  const [showOrderHistoryModal, setShowOrderHistoryModal] = useState(false);

  const [showNiniMapModal, setShowNiniMapModal] = useState(false);
  const [niniMapModalFile, setNiniMapModalFile] = useState(null);
  const [niniMapModalX, setNiniMapModalX] = useState(null);
  const [niniMapModalY, setNiniMapModalY] = useState(null);

  useEffect(() => {
    // コラムリンクボタンのラベル
    fetch("mapple01/mojmap/columnlabel.json")
      .then((response) => {
        return response.json();
      })
      .then((jsondata) => {
        setSmartphoneText(jsondata.str_innerhtml_smartphone);
        setLinkUrl(jsondata.url);
      });
  }, []);

  const isMapLoaded = useRef(false);
  useEffect(() => {
    if (isLoading || isMapLoaded.current) {
      return;
    }
    // 地図の初期化
    setHasUrlHash(window.location.hash ? true : false); // URLにハッシュ値が設定されていたか
    const { map, measureControl } = maplibreInit(
      mapContinerRef,
      isUserLoggedIn,
      addSelectedFeatures,
      deleteSelectedFeatures
    );
    setMap(map);
    // 切り替えボタン
    const btn = createSwitchBtn(true);
    setSwitchBtnClickHandler({
      btn: btn,
      map: map,
      control: measureControl,
      isAddMeasuer: true,
      setDrawCtl: setDrawCtl,
      drawColor: drawColor,
      setToast: setToastMessage,
    });
    isMapLoaded.current = true;
  }, [
    setMap,
    setDrawCtl,
    setHasUrlHash,
    drawColor,
    isLoading,
    isUserLoggedIn,
    addSelectedFeatures,
    deleteSelectedFeatures,
  ]);

  // 任意座標モーダル表示
  const handleShowNiniModal = useCallback((file, x, y) => {
    setNiniMapModalFile(file);
    setNiniMapModalX(x);
    setNiniMapModalY(y);
    setShowNiniMapModal(true);
  }, []);

  const handleCloseNiniMapModal = () => {
    setShowNiniMapModal(false);
    setNiniMapModalFile(null);
    setNiniMapModalX(null);
    setNiniMapModalY(null);
  };

  useEffect(() => {
    const niniModalListener = (e) => {
      handleShowNiniModal(e.detail.file, e.detail.x, e.detail.y);
    };
    window.addEventListener("showNiniMapModal", niniModalListener);

    return () => {
      window.removeEventListener("showNiniMapModal", niniModalListener);
    };
  }, [handleShowNiniModal]);

  // 購入履歴モーダル表示
  useEffect(() => {
    const orderHistoryModalListener = () => {
      setShowOrderHistoryModal(true);
    };
    window.addEventListener("showOrderHistoryModal", orderHistoryModalListener);

    return () => {
      window.removeEventListener(
        "showOrderHistoryModal",
        orderHistoryModalListener
      );
    };
  }, []);

  // ログインを促すダイアログ
  const showLoginPrompt = () => {
    window.dispatchEvent(
      new CustomEvent("showLoginPrompt", { detail: { showButton: false } })
    );
  };
  
  // LeftSide.jsx と同じサブスクリプション判定ロジック
  const isEnabledSubscription =
    userInfo?.attributes &&
    userInfo.attributes["custom:subscription_status"] === "active";

  return (
    <>
      <div id="map" ref={mapContinerRef}></div>
      <a
        href={linkUrl}
        id="columnLinkButton_smartphone"
        className="btn-lg btn-success rounded-pill columnButtonClass"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-book"></i>
        <span
          id="columnLinkButton_smartphone_text"
          className="columnButtonClass_text"
        >
          {smartphoneText}
        </span>
      </a>
      <div
        style={{
          display: "none",
        }}
      >
        <IndividualDrawColorSettingBtn />
      </div>
      <a
        href="#_"
        onClick={() => {
          setShowChibanSearch(true);
        }}
        className="btn-lg btn-primary rounded-pill questionnaire"
      >
        <i className="fa fa-search"></i>
        <span className="questionnaire_text">　地番検索</span>
      </a>
      {/* 地番検索モーダル */}
      <ChibanSearchModal
        show={showChibanSearch}
        handleClose={() => setShowChibanSearch(false)}
        showLoginPrompt={showLoginPrompt}
        showNiniModal={handleShowNiniModal}
      />
      {/* 購入履歴モーダル */}
      <OrderHistoryModal
        show={showOrderHistoryModal}
        handleClose={() => setShowOrderHistoryModal(false)}
        showNiniModal={handleShowNiniModal}
      />
      {/* 任意座標モーダル */}
      <NiniMapModal
        show={showNiniMapModal}
        handleClose={handleCloseNiniMapModal}
        file={niniMapModalFile}
        ninix={niniMapModalX}
        niniy={niniMapModalY}
      />
      <div
        className="maplibregl-ctrl maplibregl-ctrl-attrib"
        style={{
          position: "absolute",
          zIndex: 2,
          bottom: 0,
          backgroundColor: "hsla(0,0%,100%,.8)",
        }}
      >
        <a
          href="#_"
          style={{ fontSize: "12px" }}
          onClick={() => {
            setTokuteishohyokiModalSow(true);
          }}
        >
          特定商取引法に基づく表記
        </a>
        <TokuteishohyokiModal
          show={tokuteishohyokiModalSow}
          handleClose={() => {
            setTokuteishohyokiModalSow(false);
          }}
        />
      </div>
      {/* 広告 */}
      {!isEnabledSubscription && <GoogleAd />}

      {/* メッセージトースト */}
      <ToastContainer
        className="p-3"
        style={{
          position: "fixed",
          bottom: "1rem",
          right: "1rem",
        }}
      >
        <Toast
          onClose={() => setToastMessage(null)}
          show={!!toastMessage}
          delay={3000}
          autohide
          bg={toastMessage?.type}
        >
          <Toast.Header>
            <strong className="me-auto">{toastMessage?.title}</strong>
          </Toast.Header>
          <Toast.Body
            className={
              toastMessage?.type === "light" || toastMessage?.type === "warning"
                ? "text-dark"
                : "text-white"
            }
          >
            {toastMessage?.message.split("\n").map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default Map;
